module.exports = __webpack_public_path__ + "static/media/lips2.d639cd3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/lips2.svg
// module id = 3130
// module chunks = 7